import { Theme, Typography, useMediaQuery } from "@mui/material";
import { Datagrid, TextField, useRecordContext } from "react-admin";
import CustomAmountField from "../../unit/CustomAmountField";
import CustomDateField from "../../unit/CustomDateField";
import EmailReminder from "../actions/EmailReminder";
import ApplicationLinkField from "../ApplicationLinkField";
import MobileGrid from "../MobileGrid";
import { hmLightTheme } from "../../themes/hmTheme";
import CustomLoading from "../../unit/CustomLoading";
import { Widgets } from "@mui/icons-material";
const DaysPassedField = () => {
  const record = useRecordContext();
  if (record && record.dtNotify != null) {
    const dtNotify = new Date(record.dtNotify);
    const now = new Date();
    const diff = now.getTime() - dtNotify.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    return <span className="numericText">{days}</span>;
  }
  return "";
};

const DecisionField = () => {
  const record = useRecordContext();
  if (
    record?.sReview == "Approved" ||
    record?.sReview == "Pre-Approved" ||
    record?.sReview == "pre-approve"
  ) {
    if (
      (record?.subType == "car" || record?.preApprovePurpose == "YES") &&
      record?.sApplicationResponse == ""
    ) {
      return <Typography variant="body2">Pre-Approved</Typography>;
    } else {
      return <Typography variant="body2">Approved</Typography>;
    }
  }
  if (record && record.reviewOption) {
    return <Typography variant="body2">{record.reviewOption}</Typography>;
  } else if (record && record.recommendationOption) {
    return (
      <Typography variant="body2">{record.recommendationOption}</Typography>
    );
  }
  return <Typography></Typography>;
};

const ApplicationFeeField = () => {
  const record = useRecordContext();
  if (record && record.feesType == "online") {
    if (record.feesStatus == "succeeded" && record.feesChargeId != "") {
      return <Typography variant="body2">Paid</Typography>;
    } else {
      return <Typography variant="body2">Unpaid</Typography>;
    }
  } else if (record && record.feesType == "ach_offline") {
    if (record.feesPaid == "true") {
      return <Typography variant="body2">Paid</Typography>;
    } else {
      return <Typography variant="body2">Unpaid</Typography>;
    }
  } else {
    return <Typography variant="body2">N/A</Typography>;
  }
};
const CustomExpiredBorrowerTag = () => {
  const record = useRecordContext();
  const dtNotify = record?.dtNotify ? new Date(record.dtNotify) : null;
  const currentDate = new Date();
  const loanoffer_expiration = Number(record?.loanoffer_expiration);
  if (
    dtNotify &&
    !Number.isNaN(dtNotify.getTime()) &&
    Number.isFinite(dtNotify.getTime()) &&
    loanoffer_expiration > 0
  ) {
    const diffDays = Math.floor(
      (currentDate.getTime() - dtNotify.getTime()) / (1000 * 60 * 60 * 24)
    );
    // return diffDays + "-" + loanoffer_expiration;
    // return diffDays - loanoffer_expiration;
    if (diffDays > loanoffer_expiration) {
      return "Expired";
    }
  }
  return "";
};
const CustomBorrowerAgreement = ({ source, label }) => {
  const record = useRecordContext();
  const sExecuteStatus = record?.sExecuteStatus;
  let showText = "";

  if (record?.sClosingPerform == "IN-PERSON") {
    showText = "Offline";
  }
  if (
    record?.sExecuteStatus == "Closing Docs Created" ||
    record?.sExecuteStatus == "Closing Docs Sent"
  ) {
    showText = "Pending";
  } else if (
    record?.sExecuteStatus == "Closing Docs Received" ||
    record?.sExecuteStatus == "Closing Dos Received"
  ) {
    showText = "Completed";
  } else if (record?.sExecuteStatus == "ID check failed") {
    showText = "Error";
  }
  return (
    <Typography
      variant="body2"
      sx={showText === "Expired" ? { color: "error.main" } : undefined}
    >
      {showText}
    </Typography>
  );
};
const CustomBorrowerAgreementExpiredField = ({ source, label }) => {
  const record = useRecordContext();
  const sExecuteStatus = record?.sExecuteStatus;
  let showText = "";

  if (record?.sClosingPerform == "IN-PERSON") {
    showText = "Offline";
  }
  if (
    record?.sExecuteStatus == "Closing Docs Created" ||
    record?.sExecuteStatus == "Closing Docs Sent"
  ) {
    showText = "Pending";
  } else if (
    record?.sExecuteStatus == "Closing Docs Received" ||
    record?.sExecuteStatus == "Closing Dos Received"
  ) {
    showText = "Completed";
  } else if (record?.sExecuteStatus == "ID check failed") {
    showText = "Error";
  }
  if (showText != "Pending") {
    return <></>;
  }

  const dtNotify = record?.dtNotify ? new Date(record.dtNotify) : null;
  const currentDate = new Date();
  const loanoffer_expiration = Number(record?.loanoffer_expiration);
  if (
    dtNotify &&
    !Number.isNaN(dtNotify.getTime()) &&
    Number.isFinite(dtNotify.getTime()) &&
    loanoffer_expiration > 0
  ) {
    const diffDays = Math.floor(
      (currentDate.getTime() - dtNotify.getTime()) / (1000 * 60 * 60 * 24)
    );
    // return diffDays + "-" + loanoffer_expiration;
    // return diffDays - loanoffer_expiration;
    if (diffDays > loanoffer_expiration) {
      // return "Expired";
      return (
        <Typography variant="body2" sx={{ color: "error.main" }}>
          Passed
        </Typography>
      );
    }
  }
  return "";
};

const CustomDisbursementAgreement = ({ source, label }) => {
  const record = useRecordContext();
  const showDisplayArray: string[] = [];
  if (
    record?.sDisbursementPayment == "NO_ACH" ||
    record?.sDisbursementPayment == "MANUAL_ACH"
  ) {
    if (record?.sConfirmNoACHDisburse == "NO") {
      showDisplayArray.push("Pending");
    } else {
      showDisplayArray.push("Offline");
    }
  } else {
    if (record?.disbursementStatus) {
      if (
        record?.disbursementStatus == "success" ||
        record?.disbursementStatus == "succeed" ||
        record?.disbursementStatus == "processed"
      ) {
        showDisplayArray.push("Completed");
      } else if (
        record?.disbursementStatus == "executing" ||
        record?.disbursementStatus == "start"
      ) {
        showDisplayArray.push("In-Progress");
      } else if (
        record?.disbursementStatus?.includes("Failed") ||
        record?.disbursementStatus?.includes("fail") ||
        record?.disbursementStatus == "failed"
      ) {
        // showDisplayArray.push(record?.disbursementStatus);
        showDisplayArray.push("Failed");
      } else if (
        record?.disbursementStatus == "canceled" ||
        record?.disbursementStatus == "disabled"
      ) {
        // showDisplayArray.push("Error");
        showDisplayArray.push(record?.disbursementStatus);
      } else if (record?.disbursementStatus == "Offline") {
        //如果是smart ach, 但是是offline，也就是disbursement out side hm, 也算offline
        showDisplayArray.push("Offline");
      }
    } else {
      if (
        record?.ach_account_id == null &&
        record?.sDisbursementPayment == "SMART_ACH"
      ) {
        // showDisplayArray.push("Pending ACH");
        showDisplayArray.push("No Account");
      } else {
        showDisplayArray.push("Pending Disburse");
      }
    }
  }
  return (
    <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
      {showDisplayArray.map((text, index) => (
        <span
          key={index}
          className={`dis-status-${text.replace(/\s+/g, "-").toLowerCase()}`}
        >
          {/* {text.trim()} */}
          {/* 如果是Pending Disburse,显示Pending */}
          {text.includes("Pending Disburse") ? "Pending" : text}
          {index < showDisplayArray.length - 1 && <br />}
        </span>
      ))}
    </Typography>
  );
};

const DefaultApplicationList = ({ ...props }) => {
  const filterStatus = props.filterStatus;
  const filterSubStatus = props.filterSubStatus;
  const isXsmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("sm")
  );
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down("md"));
  const sort = { field: "id", order: "DESC" };
  const handleCallBackRefreshMenu = () => {
    if (typeof props?.handleCallBackRefreshMenu === "function") {
      props.handleCallBackRefreshMenu();
    }
  };

  //new status , for expired
  const CustomExpiredReviewTag = () => {
    const record = useRecordContext();
    const submitDate = record?.dtDocusignComplete
      ? new Date(record.dtDocusignComplete)
      : null;
    const currentDate = new Date();
    const underwriting_period_days = Number(record?.underwriting_period_days);
    if (
      submitDate &&
      !Number.isNaN(submitDate.getTime()) &&
      Number.isFinite(underwriting_period_days) &&
      underwriting_period_days > 0
    ) {
      const diffDays = Math.floor(
        (currentDate.getTime() - submitDate.getTime()) / (1000 * 60 * 60 * 24)
      );
      // return diffDays + " - " + underwriting_period_days;
      if (diffDays > underwriting_period_days) {
        return "Expired";
      }
    }
    return "";
  };
  //hold status, for expired
  const CustomExpiredHoldTag = () => {
    const record = useRecordContext();
    const submitDate = record?.dtDocusignComplete
      ? new Date(record.dtDocusignComplete)
      : null;
    const currentDate = new Date();
    const max_onhold_days = Number(record?.max_onhold_days);
    if (
      submitDate &&
      !Number.isNaN(submitDate.getTime()) &&
      Number.isFinite(max_onhold_days) &&
      max_onhold_days > 0
    ) {
      const diffDays = Math.floor(
        (currentDate.getTime() - submitDate.getTime()) / (1000 * 60 * 60 * 24)
      );
      // return diffDays + " - " + max_onhold_days;
      if (diffDays > max_onhold_days) {
        return "Expired";
      }
    }
    return "";
  };
  const VerificationField = ({ ...props }) => {
    const record = useRecordContext();
    if (record && record.referralVerify) {
      return (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100px",
            minWidth: "100px",
            maxWidth: "100px",
          }}
        >
          {record?.referralVerify == "Pending" ? (
            <>
              <Typography component="span" variant="body2">
                Pending
              </Typography>
              {record?.iCounselorVerification == 1 &&
                record?.counselor_id > 0 && (
                  <EmailReminder
                    label="Send Reminder"
                    sx={{ verticalAlign: "middle", ml: 2 }}
                    appId={record?.id}
                    reminderEvent="counselor"
                    handleCallBackRefreshMenu={handleCallBackRefreshMenu}
                  />
                )}
              {record?.iCounselorVerification != 1 &&
                record?.employment_id > 0 && (
                  <EmailReminder
                    label="Send Reminder"
                    sx={{ verticalAlign: "middle", ml: 2 }}
                    appId={record?.id}
                    reminderEvent="employer"
                    handleCallBackRefreshMenu={handleCallBackRefreshMenu}
                  />
                )}
            </>
          ) : (
            <>
              {record?.referralVerify}
              {record?.iCounselorVerification == 1 &&
                record?.referralVerify != "N/A" &&
                record?.counselor_id > 0 && (
                  <EmailReminder
                    label="Send Reminder"
                    sx={{ verticalAlign: "middle", ml: 2 }}
                    appId={record?.id}
                    reminderEvent="counselor"
                    action="resend"
                    handleCallBackRefreshMenu={handleCallBackRefreshMenu}
                  />
                )}
              {record?.iCounselorVerification != 1 &&
                record?.employment_id > 0 &&
                record?.referralVerify != "N/A" && (
                  <EmailReminder
                    label="Send Reminder"
                    sx={{ verticalAlign: "middle", ml: 2 }}
                    appId={record?.id}
                    reminderEvent="employer"
                    action="resend"
                    handleCallBackRefreshMenu={handleCallBackRefreshMenu}
                  />
                )}
            </>
          )}
        </Typography>
      );
    } else {
      return <Typography variant="body2">N/A</Typography>;
    }
  };
  const VerificationExpirationField = ({ ...props }) => {
    const record = useRecordContext();
    let sExpired = "";
    const filterSubStatus = props.filterSubStatus;
    const filterStatus = props.filterStatus;
    if (filterStatus == "Hold") {
      sExpired = CustomExpiredHoldTag();
      return (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100px",
            minWidth: "100px",
            maxWidth: "100px",
          }}
        >
          <>
            <Typography
              component="span"
              variant="body2"
              sx={sExpired == "Expired" ? { color: "error.main" } : undefined}
            >
              {sExpired == "Expired" ? "Passed" : ""}
            </Typography>
          </>
        </Typography>
      );
    } else {
      sExpired = CustomExpiredReviewTag();
      if (record && record.referralVerify) {
        return (
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100px",
              minWidth: "100px",
              maxWidth: "100px",
            }}
          >
            {record?.referralVerify == "Pending" && (
              <>
                <Typography
                  component="span"
                  variant="body2"
                  sx={
                    sExpired == "Expired" ? { color: "error.main" } : undefined
                  }
                >
                  {sExpired == "Expired" ? "Passed" : ""}
                </Typography>
              </>
            )}
          </Typography>
        );
      }
    }

    return <></>;
  };
  const CustomDaysSinceNotificationField = ({ ...props }) => {
    const record = useRecordContext();
    if (record && record.dtNotify != null) {
      // const dtNotify = new Date(record.dtNotify);
      // const now = new Date();
      // const diff = now.getTime() - dtNotify.getTime();
      // const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const notifyDate = new Date(record.dtNotify);
      notifyDate.setHours(0, 0, 0, 0);
      const diff = today.getTime() - notifyDate.getTime();
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      return <span className="numericText">{days}</span>;
    }
  };
  const CustomDaysSinceSubmissionField = ({ ...props }) => {
    const record = useRecordContext();
    if (record && record.dtDocusignComplete != null) {
      // const dtDocusignComplete = new Date(record.dtDocusignComplete);
      // const now = new Date();
      // const diff = now.getTime() - dtDocusignComplete.getTime();
      // const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const completeDate = new Date(record.dtDocusignComplete);
      completeDate.setHours(0, 0, 0, 0);

      const diff = today.getTime() - completeDate.getTime();
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      return <span className="numericText">{days}</span>;
    }
  };

  const BorrowerAcceptanceField = () => {
    const record = useRecordContext();

    if (record && record.sApplicationResponse != null) {
      const displayText =
        record.sApplicationResponse === "Accept" ? (
          "Accepted"
        ) : (
          <>
            <Typography component="span" variant="body2">
              Pending
            </Typography>
            <EmailReminder
              label={record.sApplicationResponse}
              appId={record?.id}
              record={record}
              sx={{ verticalAlign: "middle", ml: 2 }}
              reminderEvent="countered"
              handleCallBackRefreshMenu={handleCallBackRefreshMenu}
            />
          </>
        );
      return <Typography variant="body2">{displayText}</Typography>;
    }
  };
  const BorrowerAcceptanceExpiredField = () => {
    const record = useRecordContext();
    const sExpired = CustomExpiredBorrowerTag();

    if (record && record.sApplicationResponse != null) {
      return (
        <>
          {record.sApplicationResponse != "Accept" && (
            <>
              <Typography
                component="span"
                variant="body2"
                sx={sExpired == "Expired" ? { color: "error.main" } : undefined}
              >
                {sExpired == "Expired" ? "Passed" : ""}
              </Typography>
            </>
          )}
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <Datagrid
        isRowSelectable={(record) => false}
        optimized
        stickyHeader={true}
        rowClick={false}
        size="small"
        id="table-applications"
        empty={false}
        className="hm-list-datagrid"
        sx={{
          ".MuiTableCell-root": {
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },
          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          "& .MuiTableCell-root.column-last_login_time": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-amountSubmit": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            textAlign: "right",
          },
          "& .MuiTableCell-root.column-amountReview": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            textAlign: "right",
          },
          "& .MuiTableCell-root.column-dtReview": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-dtNotify": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-adverseReason": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-reviewBy": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-referral": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-referralVerify": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sProductName": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-fullname": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-dtDocusignComplete": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-dtInsert": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-iApplicationId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
          },
          "& .MuiTableCell-root.column-sLoanNum": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
          },
          "& .MuiTableCell-root.column-iUserId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
          },
          "& .MuiTableCell-root.column-dtNotifyDays": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            textAlign: "right",
          },
          "& .MuiTableCell-root.column-dtDocusignCompleteDays": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            textAlign: "right",
          },
          "& .MuiTableCell-root.column-referralVerifyHoldExpired": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-referralVerifyHoldExpired .MuiTypography-root":
            {
              width: "100%",
              textAlign: "center",
            },
          "& .MuiTableCell-root.column-referralVerifyExpired": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-referralVerifyExpired .MuiTypography-root":
            {
              width: "100%",
              textAlign: "center",
            },
          "& .MuiTableCell-root.column-borrowerAgreementExpired .MuiTypography-root":
            {
              width: "100%",
              textAlign: "center",
              display: "block",
            },
          "& .MuiTableCell-root.column-sApplicationResponseExpired .MuiTypography-root":
            {
              width: "100%",
              display: "block",
              textAlign: "center",
            },
          "& .MuiTableCell-root.column-applicationfee .MuiTypography-root": {
            width: "100%",
            display: "block",
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-sBank .MuiTypography-root": {
            width: "100%",
            display: "block",
            textAlign: "left",
          },
        }}
        // bulkActionButtons={<ApplicationListBulkActions />}
      >
        {filterStatus == "Incomplete" ? (
          <CustomDateField
            source="dtInsert"
            label="Application Started"
            onlyShowDate={true}
            cellClassName="dateText"
          />
        ) : (
          <CustomDateField
            source="dtDocusignComplete"
            label="Application Submitted"
            onlyShowDate={true}
            cellClassName="dateText"
          />
        )}
        {filterStatus == "Incomplete" ? (
          <TextField source="id" label="App #" sortBy="id" />
        ) : (
          <ApplicationLinkField
            source="iApplicationId"
            label="App #"
            sortBy="id"
          />
        )}

        {filterStatus != "Incomplete" && (
          <TextField
            source="sLoanNum"
            label="Loan #"
            cellClassName="numericText"
          />
        )}
        <TextField
          source="sProductName"
          label="Product"
          sx={{
            "& .MuiButtonBase-root .Mui-active .MuiTableSortLabel-icon": {
              color: "green",
            },
          }}
        />
        <TextField source="fullname" label="Applicant" />
        {filterStatus == "To Notify" && (
          <CustomAmountField
            source="amountSubmit"
            label="Amount Applied"
            sortBy="amountSubmit"
            cellClassName="amountText"
          />
        )}
        {filterStatus == "New" ||
        filterStatus == "Initial Review" ||
        filterStatus == "Final Review" ||
        filterStatus == "Hold" ||
        filterStatus == "Declined" ||
        filterStatus == "Incomplete" ? (
          <CustomAmountField
            source="amountSubmit"
            label="Amount Applied"
            sortBy="amountSubmit"
            cellClassName="amountText"
          />
        ) : (
          <CustomAmountField
            source="amountReview"
            label="Amount Offered"
            sortBy="amountReview"
            cellClassName="amountText"
          />
        )}
        {/* “Last Reviewed” (Initial Review, Final Review, Hold, Notification), 
          or “Date Notified” (Countered, Pre-Approved, Approved, Expired, Declined), 
          “Application Fee” (New, Incomplete) */}
        {(filterStatus == "Initial Review" ||
          filterStatus == "Final Review" ||
          filterStatus == "Hold" ||
          filterStatus == "To Notify") && (
          <CustomDateField
            source="dtReview"
            label="Last Reviewed"
            sortBy="dtReview"
            onlyShowDate={true}
            cellClassName="dateText"
          />
        )}
        {(filterStatus == "Countered" ||
          filterStatus == "Pre-Approved" ||
          filterStatus == "pre-approve" ||
          filterStatus == "CounteredAndPreApproved" ||
          filterStatus == "Approved" ||
          filterStatus == "Expired" ||
          filterStatus == "Declined") && (
          <CustomDateField
            source="dtNotify"
            label="Date Notified"
            sortBy="dtNotify"
            onlyShowDate={true}
            cellClassName="dateText"
          />
        )}
        {(filterSubStatus == "Acceptance Pending" ||
          filterSubStatus == "Pending Signature") && (
          <CustomDaysSinceNotificationField
            source="dtNotifyDays"
            label="Days Since Notification"
            sortBy="dtNotifyDays"
            sortable={true}
          />
        )}
        {(filterStatus == "New" || filterStatus == "Incomplete") && (
          <ApplicationFeeField
            source="applicationfee"
            label="Application Fee"
            sortable={false}
          />
        )}
        {/* “Verification” (New, Initial Review), 
          “Recommendation” (Final Review),
          “Decision” (Notification), 
          “Applicant Acceptance”
          (Countered,Pre-Approved), 
          “Borrower Agreement” (Approved), 
          “Days Past”(Expired), 
          */}
        {/* {filterStatus == "New" ||
            (filterStatus == "Initial Review" && (
              <ReferenceVerifyField label="Verification" />
            ))} */}
        {filterStatus == "Final Review" && (
          <TextField source="recommendationOption" label="Recommendation" />
        )}
        {filterStatus == "To Notify" && <DecisionField label="Decision" />}
        {(filterStatus == "Countered" ||
          filterStatus == "Pre-Approved" ||
          filterStatus == "pre-approve" ||
          filterStatus == "CounteredAndPreApproved") && (
          <BorrowerAcceptanceExpiredField
            source="sApplicationResponseExpired"
            label="Expiration"
          />
        )}
        {(filterStatus == "Countered" ||
          filterStatus == "Pre-Approved" ||
          filterStatus == "pre-approve" ||
          filterStatus == "CounteredAndPreApproved") && (
          <BorrowerAcceptanceField
            source="sApplicationResponse"
            label="Borrower Acceptance"
          />
        )}

        {filterStatus == "Approved" &&
          filterSubStatus == "Pending Signature" && (
            <CustomBorrowerAgreementExpiredField
              source="borrowerAgreementExpired"
              label="Expiration"
            />
          )}
        {filterStatus == "Approved" &&
          filterSubStatus == "Signature Completed" && (
            <CustomDisbursementAgreement
              source="borrowerAgreement"
              label="Disbursement Status"
            />
          )}
        {/* <TextField source="ach_account_id" label="removed ACH Account" /> */}
        {filterStatus == "Approved" &&
          filterSubStatus == "Pending Signature" && (
            <CustomBorrowerAgreement
              source="borrowerAgreement"
              label="Borrower Agreement"
            />
          )}

        {filterStatus == "Expired" && (
          <DaysPassedField
            label="Days Passed"
            sortBy="dtNotify"
            cellClassName="numericText"
          />
        )}
        {/* “Adverse Action” (Declined), 
          “Last Log In” (Incomplete), 
          “Reviewed by” (Hold) */}
        {filterStatus == "Declined" && (
          <TextField
            source="adverseReason"
            label="Adverse Action"
            sortable={false}
          />
        )}
        {filterStatus == "Incomplete" && (
          <CustomDateField
            source="last_login_time"
            label="Last Login"
            onlyShowDate={true}
            cellClassName="dateText"
          />
        )}
        {filterStatus == "Hold" && (
          <TextField source="reviewBy" label="Reviewed By" sortable={false} />
        )}

        {(filterSubStatus == "Verification Pending" ||
          filterStatus == "Hold") && (
          <CustomDaysSinceSubmissionField
            source="dtDocusignCompleteDays"
            label="Days Since Submission"
            sortBy="dtDocusignCompleteDays"
            sortable={true}
          />
        )}

        {(filterSubStatus == "Verification Pending" ||
          filterStatus == "Hold") && (
          <VerificationExpirationField
            label="Expiration"
            source={
              filterStatus == "Hold"
                ? "referralVerifyHoldExpired"
                : "referralVerifyExpired"
            }
            filterSubStatus={filterSubStatus}
            filterStatus={filterStatus}
            sortable={true}
          />
        )}
        {(filterStatus == "New" || filterStatus == "Initial Review") && (
          <VerificationField
            label="Verification"
            source="referralVerify"
            sortable={false}
          />
        )}
        {/* <ReferenceNameField label="Referral" /> */}
        <TextField source="referral" label="Referral" sortBy="referral" />

        {localStorage.getItem("authrole") == "admin" && (
          <TextField source="sBank" label="Institution" />
        )}
      </Datagrid>
    </>
  );
};

export default DefaultApplicationList;
